import {useAuthenticator} from "../auth/authenticator.tsx";
import {createRouter, RouterProvider} from "@tanstack/react-router";
import {routeTree} from "./routeTree.gen.ts";
import {SuspenseDialog} from "../components/SuspenseDialog.tsx";
import {useMemo} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {Bomb} from "../bomb/bomb.tsx";
import {AppRouterContext} from "./AppRouterContext.tsx";
import {useMothership} from "../tq/tqx.tsx";

const basepath = import.meta.env.BASE_URL;

const router = createRouter({
    routeTree,
    defaultPendingComponent: () => <SuspenseDialog message="routing..."/>,
    defaultErrorComponent: ({error}: { error: unknown }) => <Bomb error={error}/>,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    context: {} as AppRouterContext,
    basepath,
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router
    }
}

export function AppRouterProvider() {
    const auther = useAuthenticator();
    const mama = useMothership();
    const tqc = useQueryClient();
    const rctx = useMemo(() => {
        return {authenticator: auther, mothership: mama, queryClient: tqc, myself: undefined} as const;
    }, [auther, mama, tqc]);

    return <RouterProvider router={router} context={rctx}/>
}


